import React from "react";
import classNames from "classnames";
import { Button, Classes, Popover } from "@blueprintjs/core";
import styles from "./OpportunityList.module.scss";
import { Icon } from "../../atoms/Icon";

const stringRenderer = ({ className, cellData }) => (
  <div className={className}>{cellData}</div>
);

const videoNameRenderer = ({ className, cellData, rowData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    <div className={styles.imageWrapper}>
      <img
        alt="video thumbnail"
        width={41}
        height={41}
        src={rowData.thumbnailUrl}
        className={styles.thumbnail}
      />
    </div>
    <div className={styles.videoNameText}>{cellData}</div>
  </div>
);

const shareRenderer = ({ className, cellData, rowData }) => (
  <div
    className={classNames(
      className,
      styles.cellWrapper,
      styles.iconOnlyWrapper
    )}
  >
    {/* We use e.stopPropagation() on the <div> tag to prevent the table row's
     * onClick event from being fired in this case */}

    <div
      onClick={(e) => {
        e.stopPropagation();
        rowData.onShareOpportunity();
      }}
    >
      <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
        <Button icon={<Icon name="Share" />} minimal />
      </Popover>
    </div>
  </div>
);

const priceRenderer = ({ className, cellData, rowData }) => {
  return (
    <div className={classNames(className, styles.cellWrapper)}>
      {rowData.product.isDonation ? "Accepts Donations" : `$${cellData.toFixed(2)}`}
    </div>
  );
};

const salesRenderer = ({ className, cellData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    {cellData.toFixed(2)}
  </div>
);

const amountRenderer = ({ className, cellData, rowData }) => (
  <div className={classNames(className, styles.cellWrapper)}>
    {rowData.isPercentage ? `${cellData.toFixed(2)}%` : `$${cellData.toFixed(2)}`}
  </div>
);

const renderers = {
  string: stringRenderer,
  price: priceRenderer,
  salesMade: salesRenderer,
  amount: amountRenderer,
  share: shareRenderer,
  name: videoNameRenderer
};

const Cell = () => (cellProps) => {
  const format = cellProps.column.key || "string";
  const renderer = renderers[format] || renderers.string;

  return renderer(cellProps);
};

const components = () => ({
  TableCell: Cell()
});

export default components;
